import TransferringLogModule from "@/views/modules/shared/store/modules/TransferringLogModule.js";

const SharedStore = {
  TransferringLogModule,
};

export default SharedStore;
